import React, { useState } from 'react';
import { Mail, Phone, MapPin, MessageCircle } from 'lucide-react';
import { companyInfo, faqs } from '../data/mock';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real app, this would send data to a backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', email: '', phone: '', message: '' });
    }, 3000);
  };

  const handleWhatsApp = () => {
    const message = `Hi, I'm interested in EASY2HOME products. I'd like to know more.`;
    const whatsappUrl = `https://wa.me/${companyInfo.whatsapp.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div style={{ backgroundColor: '#fffef2' }}>
      {/* Hero Section */}
      <section className="section-padding">
        <div className="container">
          <div style={{ 
            textAlign: 'center',
            maxWidth: '600px',
            margin: '0 auto 64px'
          }}>
            <h1 className="hero-large" style={{ marginBottom: '16px' }}>
              Get in Touch
            </h1>
            <p className="body-large" style={{ color: '#666666' }}>
              Have questions about our products? We're here to help!
            </p>
          </div>

          <div className="grid-two-column">
            {/* Contact Information */}
            <div>
              <h2 className="heading-2" style={{ marginBottom: '24px' }}>
                Contact Information
              </h2>
              
              <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '24px',
                marginBottom: '32px'
              }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                  <div style={{
                    width: '48px',
                    height: '48px',
                    backgroundColor: '#f6f5e8',
                    borderRadius: '0px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <Mail size={24} color="#333333" />
                  </div>
                  <div>
                    <h3 className="body-regular" style={{ fontWeight: '500', marginBottom: '4px' }}>
                      Email
                    </h3>
                    <a href={`mailto:${companyInfo.email}`} className="body-regular" style={{ color: '#666666' }}>
                      {companyInfo.email}
                    </a>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                  <div style={{
                    width: '48px',
                    height: '48px',
                    backgroundColor: '#f6f5e8',
                    borderRadius: '0px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <Phone size={24} color="#333333" />
                  </div>
                  <div>
                    <h3 className="body-regular" style={{ fontWeight: '500', marginBottom: '4px' }}>
                      Phone
                    </h3>
                    <a
                      href={`tel:${companyInfo.phone}`}
                      className="body-regular"
                      style={{
                        color: '#333333',
                        backgroundColor: '#f0e27a',
                        display: 'inline-block',
                        padding: '4px 10px',
                        fontWeight: '700'
                      }}
                    >
                      {companyInfo.phone}
                    </a>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                  <div style={{
                    width: '48px',
                    height: '48px',
                    backgroundColor: '#f6f5e8',
                    borderRadius: '0px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <MapPin size={24} color="#333333" />
                  </div>
                  <div>
                    <h3 className="body-regular" style={{ fontWeight: '500', marginBottom: '4px' }}>
                      Address
                    </h3>
                    <p className="body-regular" style={{ color: '#666666' }}>
                      {companyInfo.address}
                    </p>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                  <div style={{
                    width: '48px',
                    height: '48px',
                    backgroundColor: '#f6f5e8',
                    borderRadius: '0px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <MessageCircle size={24} color="#333333" />
                  </div>
                  <div>
                    <h3 className="body-regular" style={{ fontWeight: '500', marginBottom: '8px' }}>
                      WhatsApp
                    </h3>
                    <button onClick={handleWhatsApp} className="btn-primary" style={{ minWidth: 'auto' }}>
                      Chat with us
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div style={{
              backgroundColor: '#f6f5e8',
              padding: '40px',
              borderRadius: '0px'
            }}>
              <h2 className="heading-2" style={{ marginBottom: '24px' }}>
                Send us a Message
              </h2>

              {submitted ? (
                <div style={{
                  backgroundColor: '#fffef2',
                  padding: '24px',
                  borderRadius: '0px',
                  textAlign: 'center'
                }}>
                  <p className="body-large" style={{ color: '#333333', fontWeight: '500' }}>
                    Thank you for your message!
                  </p>
                  <p className="body-regular" style={{ color: '#666666', marginTop: '8px' }}>
                    We'll get back to you soon.
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div style={{ marginBottom: '20px' }}>
                    <label className="body-regular" style={{ 
                      display: 'block', 
                      marginBottom: '8px',
                      fontWeight: '500'
                    }}>
                      Name *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: '1px solid #bcbbb4',
                        borderRadius: '0px',
                        backgroundColor: '#fffef2',
                        fontSize: '14px',
                        fontFamily: 'Inter, sans-serif'
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <label className="body-regular" style={{ 
                      display: 'block', 
                      marginBottom: '8px',
                      fontWeight: '500'
                    }}>
                      Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: '1px solid #bcbbb4',
                        borderRadius: '0px',
                        backgroundColor: '#fffef2',
                        fontSize: '14px',
                        fontFamily: 'Inter, sans-serif'
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <label className="body-regular" style={{ 
                      display: 'block', 
                      marginBottom: '8px',
                      fontWeight: '500'
                    }}>
                      Phone
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: '1px solid #bcbbb4',
                        borderRadius: '0px',
                        backgroundColor: '#fffef2',
                        fontSize: '14px',
                        fontFamily: 'Inter, sans-serif'
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '24px' }}>
                    <label className="body-regular" style={{ 
                      display: 'block', 
                      marginBottom: '8px',
                      fontWeight: '500'
                    }}>
                      Message *
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="5"
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: '1px solid #bcbbb4',
                        borderRadius: '0px',
                        backgroundColor: '#fffef2',
                        fontSize: '14px',
                        fontFamily: 'Inter, sans-serif',
                        resize: 'vertical'
                      }}
                    />
                  </div>

                  <button type="submit" className="btn-primary" style={{ width: '100%' }}>
                    Send Message
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="section-padding-small" style={{ backgroundColor: '#f6f5e8' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ 
            textAlign: 'center', 
            marginBottom: '48px' 
          }}>
            Frequently Asked Questions
          </h2>

          <div style={{
            maxWidth: '800px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '24px'
          }}>
            {faqs.map((faq, index) => (
              <div key={index} style={{
                backgroundColor: '#fffef2',
                padding: '24px',
                borderRadius: '0px'
              }}>
                <h3 className="body-regular" style={{ 
                  fontWeight: '500',
                  marginBottom: '12px'
                }}>
                  {faq.question}
                </h3>
                <p className="body-regular" style={{ color: '#666666', lineHeight: '1.6' }}>
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
